<template>
  <section>
    <p>{{ (page - 1) * 20 }}-{{ page * 20 < total_answer_count ? page * 20 : total_answer_count }} of {{ total_answer_count }} Responses</p>
    <div>
      <a-button @click="handleSelectFavorites">
        Show Favorites
        <a-icon type="star" :theme="star_theme" twoToneColor="#FFBF1D"/>
      </a-button>
      <a-dropdown v-if="is_nps_survey">
        <a-menu slot="overlay" @click="handleSelectNPS">
          <a-menu-item key="All Nps">All NPS</a-menu-item>
          <a-menu-item key="Promoters">Promoters</a-menu-item>
          <a-menu-item key="Passives">Passives</a-menu-item>
          <a-menu-item key="Detractors">Detractors</a-menu-item>
        </a-menu>
        <a-button>
          {{ selected_nps }} <a-icon type="down" />
        </a-button>
      </a-dropdown>
      <!-- <a-dropdown>
        <a-menu slot="overlay" @click="handleSelectGender">
          <a-menu-item key="Female">Female</a-menu-item>
          <a-menu-item key="Male">Male</a-menu-item>
          <a-menu-item key="All Genders">All Genders</a-menu-item>
        </a-menu>
        <a-button>
          {{ selected_gender }} <a-icon type="down" />
        </a-button>
      </a-dropdown>
      <a-dropdown>
        <a-menu slot="overlay" @click="handleSelectAge">
          <a-menu-item key="11-18">11-18</a-menu-item>
          <a-menu-item key="19-29">19-29</a-menu-item>
          <a-menu-item key="30-39">30-39</a-menu-item>
          <a-menu-item key="40-49">40-49</a-menu-item>
          <a-menu-item key="50-59">50-59</a-menu-item>
          <a-menu-item key="60-69">60-69</a-menu-item>
          <a-menu-item key="All Ages">All Ages</a-menu-item>
        </a-menu>
        <a-button>
          {{ selected_age }} <a-icon type="down" />
        </a-button>
      </a-dropdown>
      <a-dropdown>
        <a-menu slot="overlay" @click="handleSelectLocation">
          <a-menu-item key="Indonesia">Indonesia</a-menu-item>
          <a-menu-item key="All Locations">All Locations</a-menu-item>
        </a-menu>
        <a-button>
          {{ selected_location }} <a-icon type="down" />
        </a-button>
      </a-dropdown> -->
    </div>

  </section>
</template>

<script>
export default {
  name: 'Filters',
  props: {
    page: Number,
    total_answer_count: Number
  },
  data() {
    return {
      selected_favorites: false,
      selected_nps: 'All NPS',
      selected_gender: 'All Genders',
      selected_age: 'All Ages',
      selected_location: 'All Locations'
    }
  },
  computed: {
    star_theme() {
      return this.selected_favorites === true ? 'twoTone' : 'outlined';
    },
    is_nps_survey() {
      return this.$store.state.surveys[this.$route.params.survey_index].nps;
    },
  },
  methods: {
    handleSelectFavorites(e) {
      this.selected_favorites = !this.selected_favorites;
      this.$emit('selectedFavorites', this.selected_favorites);
    },
    handleSelectNPS(e) {
      this.selected_nps = e.key;
      this.$emit('selectedNPS', this.selected_nps);
    },
    handleSelectGender(e) {
      this.selected_gender = e.key;
      this.$emit('selectedGender', this.selected_gender.toLowerCase());
    },
    handleSelectAge(e) {
      this.selected_age = e.key;
      if (this.selected_age === "All Ages") {
        this.$emit('selectedAge', null);
      } else {
        let [min_age, max_age] = this.selected_age.split('-');
        this.$emit('selectedAge', min_age, max_age);
      }
    },
    handleSelectLocation(e) {
      this.selected_location = e.key;
      this.$emit('selectedLocation', this.selected_location);
    }
  }
}
</script>

<style scoped lang="scss">

section{
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  p, .ant-btn{
    font-family:'Montserrat';
    color: #0D303F;
    font-size: 14px;
    font-weight: 600;
  }
  p{
    float: left;
    margin-top: 5px;
    margin-bottom: 0;
  }
  &>*{
    display: inline-block;
  }
  .ant-btn{
    margin-left: 12px;
    &:hover{
      border-color: #1BD285;
    }
    &:active{
      border-color: #1BD285;
    }
    &:focus{
      border-color: #1BD285;
    }
  }
}

.ant-dropdown-menu-item:hover{
  background-color: rgb(245,245,245);
}

</style>
